import axios from "axios";

export const API = axios.create({
  baseURL: "https://denprotocoladmin-api.skyapi.store/",
 //  baseURL: "http://localhost:1955/",
});
